import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { passwordReset } from 'store/modules/user/actions';

import Component from './component';

const mapDispatchToProps = (dispatch: Dispatch): object => {
    return {
        actions: {
            passwordReset: bindActionCreators(passwordReset, dispatch),
        },
    };
};

Component.defaultProps = {
    onSuccess: null,
};
export default connect(null, mapDispatchToProps)(Component);
